import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, MapPin, ArrowRight } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="footer-dark">
      <div className="footer-content">
        <div className="footer-grid">
          {/* Brand Section */}
          <div className="footer-section">
            <img 
              src="https://customer-assets.emergentagent.com/job_ntg-automation-hub/artifacts/8h1o92qr_SGN_06_20_2023_1687220536718.PNG" 
              alt="NTG Logo" 
              className="footer-logo"
            />
            <p className="footer-description">
              Empowering SMEs to scale in the rapidly evolving technological landscape through AI-driven automation solutions.
            </p>
          </div>

          {/* Quick Links */}
          <div className="footer-section">
            <h4 className="footer-heading">Quick Links</h4>
            <nav className="footer-links">
              <Link to="/" className="footer-link">Home</Link>
              <Link to="/services" className="footer-link">Services</Link>
              <Link to="/case-studies" className="footer-link">Case Studies</Link>
              <Link to="/about" className="footer-link">About</Link>
            </nav>
          </div>

          {/* Services */}
          <div className="footer-section">
            <h4 className="footer-heading">Our Services</h4>
            <nav className="footer-links">
              <Link to="/services" className="footer-link">Workflow Automation</Link>
              <Link to="/services" className="footer-link">Process Auditing</Link>
              <Link to="/services" className="footer-link">AI Consultation</Link>
              <Link to="/services" className="footer-link">Build AI Agents</Link>
            </nav>
          </div>

          {/* Contact Info */}
          <div className="footer-section">
            <h4 className="footer-heading">Contact Us</h4>
            <div className="footer-contact">
              <a href="mailto:hello@ntgtech.ai" className="footer-contact-item">
                <Mail size={18} />
                <span>hello@ntgtech.ai</span>
              </a>
              <div className="footer-contact-item">
                <MapPin size={18} />
                <span>673 Blackbird Station Road<br />Delaware, 19734</span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="footer-bottom">
          <p className="footer-copyright">
            © {new Date().getFullYear()} NTG Technologies. All rights reserved.
          </p>
          <div className="footer-bottom-links">
            <Link to="/privacy" className="footer-bottom-link">Privacy Policy</Link>
            <Link to="/terms" className="footer-bottom-link">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
